import { applyMiddleware, createStore, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from 'redux-logger'
const loggerMiddleware = createLogger()
const rootReducer = {};
const middlewareEnhancer = applyMiddleware(thunkMiddleware,loggerMiddleware);
const files = require.context(".", false, /\.js$/);
files.keys().forEach((k) => {
  if (k === "./index.js") return;
  rootReducer[k.replace(/\.\/(.*)\.js/, "$1")] = files(k).default;
});
const store = createStore(
  combineReducers(rootReducer),
  middlewareEnhancer
);
window.$store = store
export default store;
